@for (grupp of gruppInformation; track $index) {
  <div>
    <rask-produktval-table
      [layout]="layout"
      [handelssortimentsgruppInformation]="grupp"
      [allahandelssortimentsgrupper]="handelssortimentsgrupper"
      [handelssortimentsgrupper]="handelssortimentsgrupperHandelssortiment[grupp.handelssortimentsgruppNamn]"
      [produktvalsrader]="handelssortimentsgruppProduktvalsrader[grupp.handelssortimentsgruppNamn]"
      [visaEndastMedProduktionsmal]="visaEndastMedProduktionsmal"
      [isProduktvalApplicable]="isProduktvalApplicable"
      [isSimuleringApplicable]="isSimuleringApplicable"
      [mall]="mall"
      [onBeforeSelectionEvent]="onBeforeSelectionEvent"
      (onSelectionEvent)="onSelectionEvent($event)"
      [canEdit]="canEdit">
    </rask-produktval-table>
  </div>
}
